import * as React from "react";

export interface FocusManagementWrapperProps {
    children: React.ReactNode;
    exclusiveFocusByPath?: boolean;
}

export const FocusManagementWrapper = (props: FocusManagementWrapperProps): JSX.Element => {
    const newChildren = React.Children.map(props.children, child =>
        React.isValidElement(child)
            ? // @ts-ignore
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              React.cloneElement(child, { ...child.props, exclusiveFocusByPath: props.exclusiveFocusByPath })
            : child
    );
    return <>{newChildren}</>;
};
